import Lottie from "lottie-react"
import styled from "styled-components/macro"

export const Animation = styled(Lottie)`
  width: 50%;
  margin: 0 auto;
`
